var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f8fb4cfcaf6d37e625c3eb370ef133c8eb8c20ea"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["foodizmart@graha-foodizmart"]={id:"f8fb4cfcaf6d37e625c3eb370ef133c8eb8c20ea"};
      